import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { BeaconError, BeaconErrorType } from '..';
/**
 * @category Error
 */

export var NoPrivateKeyBeaconError = /*#__PURE__*/function (_BeaconError) {
  _inherits(NoPrivateKeyBeaconError, _BeaconError);

  var _super = _createSuper(NoPrivateKeyBeaconError);

  function NoPrivateKeyBeaconError() {
    var _this;

    _classCallCheck(this, NoPrivateKeyBeaconError);

    _this = _super.call(this, BeaconErrorType.NO_PRIVATE_KEY_FOUND_ERROR, 'The account you are trying to interact with is not available. Please make sure to add the account to your wallet and try again.');
    _this.name = 'NoPrivateKeyBeaconError';
    _this.title = 'Account Not Found';
    return _this;
  }

  return _createClass(NoPrivateKeyBeaconError);
}(BeaconError);